// Dependencies
import React from 'react';
import PropTypes from 'prop-types';

// Components
import Container from '../container/container';

// Styles
import TitleStyles from './title.styles';

export default function Title({ children, alignment }) {
  return (
    <TitleStyles alignment={alignment}>
      <Container>
        <div className="inner">
          <h1 className="title">{children}</h1>
        </div>
      </Container>
    </TitleStyles>
  );
}

Title.propTypes = {
  children: PropTypes.node.isRequired,
  alignment: PropTypes.string.isRequired,
};
